// Navigation reference — single source of truth for the app's menu.
//
// Generated from the raw design layout's `menuData` variable
// (RawHTMLDesign/layouts/_default-web-layout.html). Each leaf records:
//   - pageId  : the design's numeric page id
//   - slug    : the slug-based route the page is served at (derived from the
//               page's design folder under RawHTMLDesign/, the canonical slug
//               ui-components-from-reference uses when it generates the page)
//   - label   : the page/menu display name
//   - icon    : Font Awesome icon class
//
// The layout navigation routes by **slug**, never by page id. Until a page's
// real component is generated, its slug route falls through to the 404 catch-all.

export const menuData = {
  defaultSlug: 'client-analytics-dashboard',
  groups: [
    {
      label: 'COD Reconciliation',
      icon: 'fa fa-money-check-alt',
      children: [
        { label: 'Finance Overview', icon: 'fa fa-gauge-high', slug: 'finance-overview', pageId: 0 },
        { label: 'Remittance Uploader', icon: 'fa fa-upload', slug: 'cod-remittance-uploader', pageId: 72713 },
        { label: 'Discrepancy Worklist', icon: 'fa fa-exclamation-triangle', slug: 'cod-discrepancy-reconciliation-worklist', pageId: 72714 },
        { label: 'Merchant COD Status', icon: 'fa fa-coins', slug: 'merchant-cod-collections', pageId: 72715 },
      ],
    },
    {
      label: 'Order Management',
      icon: 'fa fa-boxes',
      children: [
        { label: 'Order Routing Rules', icon: 'fa fa-random', slug: 'order-routing-rules-setup', pageId: 72709 },
        { label: 'Warehouse Orders Queue', icon: 'fa fa-list-ol', slug: 'warehouse-orders-queue', pageId: 72710 },
      ],
    },
    {
      label: 'Dashboards',
      icon: 'fa fa-tachometer-alt',
      children: [
        { label: 'Merchant Orders', icon: 'fa fa-shopping-bag', slug: 'merchant-orders-dashboard', pageId: 72711 },
        { label: 'Client Analytics Dashboard', icon: 'fa fa-chart-line', slug: 'client-analytics-dashboard', pageId: 72718 },
        { label: 'Regional Performance', icon: 'fa fa-globe-asia', slug: 'regional-merchant-performance', pageId: 72734 },
      ],
    },
    {
      label: 'Native WMS',
      icon: 'fa fa-warehouse',
      children: [
        { label: 'Warehouse Overview', icon: 'fa fa-gauge-high', slug: 'warehouse-overview', pageId: 0 },
        { label: 'Directed Putaway', icon: 'fa fa-route', slug: 'directed-putaway-stock-movement-monitor', pageId: 72719 },
        { label: 'Inbound Receiving', icon: 'fa fa-download', slug: 'inbound-po-receiving-qa-terminal', pageId: 72720 },
        { label: 'Location Designer', icon: 'fa fa-drafting-compass', slug: 'warehouse-location-designer-bin-configurator', pageId: 72721 },
        { label: 'Cycle Counting Console', icon: 'fa fa-clipboard-check', slug: 'cycle-count-inventory-adjustment-console', pageId: 72722 },
        { label: 'Pick Queue Execution', icon: 'fa fa-barcode', slug: 'pick-queue-execution', pageId: 72737 },
        { label: 'Packing Station Terminal', icon: 'fa fa-box-open', slug: 'packing-station-terminal', pageId: 72738 },
        { label: 'Wave Picking Console', icon: 'fa fa-layer-group', slug: 'wave-batch-picking-console', pageId: 72739 },
        { label: 'Replenishment Planner', icon: 'fa fa-sync-alt', slug: 'replenishment-min-max-planner', pageId: 72740 },
        { label: 'Storage Occupancy Monitor', icon: 'fa fa-cubes', slug: 'storage-location-occupancy-monitor', pageId: 72741 },
        { label: 'Bin Transfer Terminal', icon: 'fa fa-exchange-alt', slug: 'bin-transfer-adjustment-terminal', pageId: 72742 },
      ],
    },
    {
      label: 'Integrations',
      icon: 'fa fa-network-wired',
      children: [
        { label: 'Channel Catalog', icon: 'fa fa-store', slug: 'channel-integration-catalog', pageId: 72735 },
        { label: 'API & Sync Monitor', icon: 'fa fa-heartbeat', slug: 'integration-sync-api-monitor', pageId: 72736 },
      ],
    },
    {
      label: 'Administration',
      icon: 'fa fa-user-shield',
      children: [
        { label: 'Regional Overview', icon: 'fa fa-gauge-high', slug: 'regional-overview', pageId: 0 },
        { label: 'Country Operations Profile', icon: 'fa fa-map-marked-alt', slug: 'country-operations-profile', pageId: 72731 },
      ],
    },
    {
      label: 'Courier Admin',
      icon: 'fa fa-truck-moving',
      children: [
        { label: 'Courier Integrations', icon: 'fa fa-plug', slug: 'courier-settings-service-zones', pageId: 72712 },
        { label: 'Cross-Border Logistics', icon: 'fa fa-globe', slug: 'cross-border-logistics-dashboard', pageId: 72733 },
      ],
    },
    {
      label: 'Billing & e-Invoice',
      icon: 'fa fa-file-invoice-dollar',
      children: [
        { label: 'Billing Rule Config', icon: 'fa fa-cogs', slug: 'client-billing-rule-configurator', pageId: 72716 },
        { label: 'e-Invoices Gate', icon: 'fa fa-fingerprint', slug: 'billing-e-invoices-gate', pageId: 72717 },
        { label: 'Regional Tax & FX Rate', icon: 'fa fa-chart-bar', slug: 'regional-tax-and-currency-manager', pageId: 72732 },
      ],
    },
  ],
};

// Flat list of every page referenced by the menu — pageId / slug / name lookup.
export const menuPages = menuData.groups.flatMap((g) =>
  g.children.map((c) => ({ pageId: c.pageId, slug: c.slug, name: c.label })),
);

export const findPageBySlug = (slug) => menuPages.find((p) => p.slug === slug) || null;

export default menuData;
